var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPattern = function SvgPattern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pattern_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 5.406,
    y: 3.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__d)",
    d: "M16 14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 11 18.08 11 19.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C28 12.52 28 13.08 28 14.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C26.48 23 25.92 23 24.8 23h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16 21.48 16 20.92 16 19.8z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M19.2 11.188h5.6c.563 0 .974 0 1.299.026.321.026.541.077.724.17.341.175.619.452.792.793.094.183.145.403.171.724.027.325.026.736.026 1.3V19.8c0 .563 0 .974-.026 1.299-.026.321-.078.541-.17.724a1.8 1.8 0 0 1-.793.792c-.183.094-.403.145-.724.171-.325.027-.736.026-1.3.026H19.2c-.563 0-.974 0-1.299-.026-.321-.026-.541-.078-.724-.17a1.8 1.8 0 0 1-.792-.793c-.094-.183-.145-.403-.171-.724-.027-.325-.026-.736-.026-1.3V14.2c0-.563 0-.974.026-1.299.026-.321.078-.541.17-.724.174-.341.452-.618.793-.792.183-.094.403-.145.724-.171.325-.027.736-.027 1.3-.027Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 5.406,
    y: 25.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__g)",
    fillOpacity: 0.5,
    d: "M16 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 33 18.08 33 19.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C28 34.52 28 35.08 28 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C26.48 45 25.92 45 24.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16 43.48 16 42.92 16 41.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__h)",
    fillOpacity: 0.25,
    d: "M16 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 33 18.08 33 19.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C28 34.52 28 35.08 28 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C26.48 45 25.92 45 24.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16 43.48 16 42.92 16 41.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M19.2 33.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025h-5.6c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: -7.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__k)",
    fillOpacity: 0.5,
    d: "M4 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 0 6.08 0 7.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 1.52 16 2.08 16 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 12 13.92 12 12.8 12H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 10.48 4 9.92 4 8.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__l)",
    fillOpacity: 0.25,
    d: "M4 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 0 6.08 0 7.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 1.52 16 2.08 16 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 12 13.92 12 12.8 12H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 10.48 4 9.92 4 8.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M7.2.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025H7.2c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608C4.5 9.765 4.5 9.368 4.5 8.8V3.2c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138C6.235.5 6.632.5 7.2.5Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: 14.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__m)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__n)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__o)",
    fillOpacity: 0.2,
    d: "M4 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 22 6.08 22 7.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 23.52 16 24.08 16 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 34 13.92 34 12.8 34H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 32.48 4 31.92 4 30.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__p)",
    d: "M4 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 22 6.08 22 7.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 23.52 16 24.08 16 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 34 13.92 34 12.8 34H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 32.48 4 31.92 4 30.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M7.2 22.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025H7.2c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: 36.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__q)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__r)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__s)",
    fillOpacity: 0.2,
    d: "M4 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 44 6.08 44 7.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 45.52 16 46.08 16 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 56 13.92 56 12.8 56H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 54.48 4 53.92 4 52.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__t)",
    d: "M4 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 44 6.08 44 7.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 45.52 16 46.08 16 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 56 13.92 56 12.8 56H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 54.48 4 53.92 4 52.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M7.2 44.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025H7.2c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 29.406,
    y: 3.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__u)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__v)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__w)",
    d: "M40 14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C41.52 11 42.08 11 43.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C52 12.52 52 13.08 52 14.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C50.48 23 49.92 23 48.8 23h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C40 21.48 40 20.92 40 19.8z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M43.2 11.188h5.6c.563 0 .975 0 1.299.026.321.026.541.077.724.17.341.175.618.452.792.793.093.183.145.403.171.724.027.325.026.736.026 1.3V19.8c0 .563 0 .974-.026 1.299-.026.321-.078.541-.17.724a1.8 1.8 0 0 1-.793.792c-.183.094-.403.145-.724.171-.324.027-.736.026-1.3.026H43.2c-.563 0-.975 0-1.299-.026-.321-.026-.541-.078-.724-.17a1.8 1.8 0 0 1-.792-.793c-.093-.183-.145-.403-.171-.724-.027-.325-.026-.736-.026-1.3V14.2c0-.563 0-.974.026-1.299.026-.321.078-.541.17-.724.175-.341.452-.618.793-.792.183-.094.403-.145.724-.171.324-.027.736-.027 1.3-.027Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 29.406,
    y: 25.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__x)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__y)",
    shapeRendering: "crispEdges"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__z)",
    fillOpacity: 0.5,
    d: "M40 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C41.52 33 42.08 33 43.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C52 34.52 52 35.08 52 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C50.48 45 49.92 45 48.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C40 43.48 40 42.92 40 41.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__A)",
    fillOpacity: 0.25,
    d: "M40 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C41.52 33 42.08 33 43.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C52 34.52 52 35.08 52 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C50.48 45 49.92 45 48.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C40 43.48 40 42.92 40 41.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M43.2 33.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025h-5.6c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: -7.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__B)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__C)",
    shapeRendering: "crispEdges"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__D)",
    fillOpacity: 0.5,
    d: "M28 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 0 30.08 0 31.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 1.52 40 2.08 40 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 12 37.92 12 36.8 12h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 10.48 28 9.92 28 8.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__E)",
    fillOpacity: 0.25,
    d: "M28 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 0 30.08 0 31.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 1.52 40 2.08 40 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 12 37.92 12 36.8 12h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 10.48 28 9.92 28 8.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M31.2.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025h-5.6c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273V3.2c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138C30.235.5 30.632.5 31.2.5Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: 14.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__F)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__G)",
    shapeRendering: "crispEdges"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__H)",
    fillOpacity: 0.2,
    d: "M28 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 22 30.08 22 31.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 23.52 40 24.08 40 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 34 37.92 34 36.8 34h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 32.48 28 31.92 28 30.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__I)",
    d: "M28 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 22 30.08 22 31.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 23.52 40 24.08 40 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 34 37.92 34 36.8 34h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 32.48 28 31.92 28 30.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M31.2 22.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025h-5.6c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: 36.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#pattern_svg__J)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#pattern_svg__K)",
    shapeRendering: "crispEdges"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__L)",
    fillOpacity: 0.2,
    d: "M28 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 44 30.08 44 31.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 45.52 40 46.08 40 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 56 37.92 56 36.8 56h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 54.48 28 53.92 28 52.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern_svg__M)",
    d: "M28 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 44 30.08 44 31.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 45.52 40 46.08 40 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 56 37.92 56 36.8 56h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 54.48 28 53.92 28 52.8z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M31.2 44.5h5.6c.568 0 .965 0 1.273.025.302.025.476.071.608.138.282.144.512.374.656.656.067.132.113.306.138.608.025.308.025.705.025 1.273v5.6c0 .568 0 .965-.025 1.273-.025.302-.071.476-.138.608a1.5 1.5 0 0 1-.656.656c-.132.067-.306.113-.608.138-.308.025-.705.025-1.273.025h-5.6c-.568 0-.965 0-1.273-.025-.302-.025-.476-.071-.608-.138a1.5 1.5 0 0 1-.656-.656c-.067-.132-.113-.306-.138-.608-.025-.308-.025-.705-.025-1.273v-5.6c0-.568 0-.965.025-1.273.025-.302.071-.476.138-.608.144-.282.374-.512.656-.656.132-.067.306-.113.608-.138.308-.025.705-.025 1.273-.025Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__b",
    transform: "translate(-5.406 -3.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 11 18.08 11 19.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C28 12.52 28 13.08 28 14.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C26.48 23 25.92 23 24.8 23h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16 21.48 16 20.92 16 19.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__e",
    transform: "translate(-5.406 -25.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C17.52 33 18.08 33 19.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C28 34.52 28 35.08 28 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C26.48 45 25.92 45 24.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C16 43.48 16 42.92 16 41.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__i",
    transform: "translate(6.594 7.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 0 6.08 0 7.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 1.52 16 2.08 16 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 12 13.92 12 12.8 12H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 10.48 4 9.92 4 8.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__m",
    transform: "translate(6.594 -14.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 22 6.08 22 7.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 23.52 16 24.08 16 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 34 13.92 34 12.8 34H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 32.48 4 31.92 4 30.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__q",
    transform: "translate(6.594 -36.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C5.52 44 6.08 44 7.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 45.52 16 46.08 16 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 56 13.92 56 12.8 56H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C4 54.48 4 53.92 4 52.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__u",
    transform: "translate(-29.406 -3.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C41.52 11 42.08 11 43.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C52 12.52 52 13.08 52 14.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C50.48 23 49.92 23 48.8 23h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C40 21.48 40 20.92 40 19.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__x",
    transform: "translate(-29.406 -25.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 36.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C41.52 33 42.08 33 43.2 33h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C52 34.52 52 35.08 52 36.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C50.48 45 49.92 45 48.8 45h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C40 43.48 40 42.92 40 41.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__B",
    transform: "translate(-17.406 7.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 0 30.08 0 31.2 0h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 1.52 40 2.08 40 3.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 12 37.92 12 36.8 12h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 10.48 28 9.92 28 8.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__F",
    transform: "translate(-17.406 -14.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 25.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 22 30.08 22 31.2 22h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 23.52 40 24.08 40 25.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 34 37.92 34 36.8 34h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 32.48 28 31.92 28 30.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__J",
    transform: "translate(-17.406 -36.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 47.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C29.52 44 30.08 44 31.2 44h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C40 45.52 40 46.08 40 47.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C38.48 56 37.92 56 36.8 56h-5.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C28 54.48 28 53.92 28 52.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pattern_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__d",
    x1: 22.375,
    x2: 22.375,
    y1: 11.177,
    y2: 31.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__g",
    x1: 22,
    x2: 22,
    y1: 38.325,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__k",
    x1: 10,
    x2: 10,
    y1: 5.325,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__o",
    x1: 10,
    x2: 10,
    y1: 27.325,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__s",
    x1: 10,
    x2: 10,
    y1: 49.325,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__w",
    x1: 46.375,
    x2: 46.375,
    y1: 11.177,
    y2: 31.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__z",
    x1: 46,
    x2: 46,
    y1: 38.325,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__D",
    x1: 34,
    x2: 34,
    y1: 5.325,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__H",
    x1: 34,
    x2: 34,
    y1: 27.325,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pattern_svg__L",
    x1: 34,
    x2: 34,
    y1: 49.325,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__c",
    width: 33.188,
    height: 33.188,
    x: 5.406,
    y: 3.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__f",
    width: 33.188,
    height: 33.188,
    x: 5.406,
    y: 25.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__j",
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: -7.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__n",
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: 14.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__r",
    width: 33.188,
    height: 33.188,
    x: -6.594,
    y: 36.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__v",
    width: 33.188,
    height: 33.188,
    x: 29.406,
    y: 3.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__y",
    width: 33.188,
    height: 33.188,
    x: 29.406,
    y: 25.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__C",
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: -7.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__G",
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: 14.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pattern_svg__K",
    width: 33.188,
    height: 33.188,
    x: 17.406,
    y: 36.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4387",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__h",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__l",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__p",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__t",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__A",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__E",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__I",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern_svg__M",
    width: 5.333,
    height: 5.333,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern_svg__N",
    transform: "scale(.0052)"
  })))));
};
export default SvgPattern;